import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getAllSupplyOrder = (orderStatus, page = 0, size = 1000, filters) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllSupplyOrder, { status: orderStatus.join(','), page, size, ...filters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getSpoById = (spo_no) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getSpoById, { spo_no })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
